import { rewriteHtml } from "@rewriters/html";
import { ScramjetClient } from "@client/index";
import { ForeignContext } from "@/shared/rewriters/html";
import { String } from "@/shared/snapshot";

// TODO: this function is untested / llm slop
function foreignContextForRange(
	client: ScramjetClient,
	range: Range
): ForeignContext {
	const node = range.startContainer;
	const element = node.nodeType === 1 ? node : node.parentElement;
	if (!element) return "html";
	if (client.box.instanceof(element, "SVGElement")) return "svg";
	if (client.box.instanceof(element, "MathMLElement")) return "math";
	return "html";
}

export default function (client: ScramjetClient, _self: Self) {
	client.Proxy("Range.prototype.createContextualFragment", {
		apply(ctx) {
			const html = String(ctx.args[0]);
			ctx.args[0] = rewriteHtml(html, client.context, client.meta, {
				loadScripts: false,
				inline: true,
				source: client.url.href,
				apisource: "Range.prototype.createContextualFragment",
				foreignContext: foreignContextForRange(client, ctx.this),
			});
		},
	});
}
